import { parse } from 'date-fns';

export const parseDate = (date: string) => parse(date, 'd.MM.yyyy', new Date());
